import {get} from "lodash"

import {User} from "@irati/types"
import tracking from "@irati-tracking/platform"
import errorCodes from "../errorCodes/legacy/Onboarding"

import {createOnboarding, resendWelcomeEmail} from "../services/onboarding"

export default function handleOnboardingDoesNotExist(err: PBError, user: User): Promise<any> {
  const createOnboardingOnFail = get(err, "config.createOnboardingOnFail", false)
  const notFound = get(err, "response.data.code") === errorCodes.OnboardingNotFound

  if (createOnboardingOnFail && notFound) {
    tracking.onBoarding("Step 0")
    return createOnboarding(user).then(() => {
      return resendWelcomeEmail(user)
    })
  }

  throw err
}
